<template>
        <nav :class="['side-navbar', { 'os-host os-theme-dark os-host-resize-disabled os-host-scrollbar-horizontal-hidden os-host-transition shrink os-host-overflow os-host-overflow-y': isCollapsed }]">
        <div class="scroll-container">
            <div
                class="sidebar-header d-flex align-items-center justify-content-center p-3 mb-3">
                <div class="sidenav-header-inner text-center">
                <img class="img-fluid rounded-circle avatar mb-3" :src="getImageUrl(unidade.logo)" alt="Logo da unidade" />
                        <h2 class="h5 text-white text-uppercase mb-0">{{ unidade.nome }}</h2>
                        <p class="text-sm mb-0 text-muted text-version">v{{ version }}</p>
                </div>
                <a class="brand-small text-center" href="#">
                    <p class="h1 m-0">WC</p>
                </a>
            </div>
            <span
                class="text-uppercase text-gray-500 text-sm fw-bold letter-spacing-0 mx-lg-2 heading"
                >MENU</span

                >
            <ul class="list-unstyled">
                <li class="sidebar-item" v-if="isAdmin">
                    <router-link
                        class="sidebar-link"
                        :to="'/v2/unidades/' + unidade.id + '/winckieel-intelligence'"
                        :class="{ active: isActive('WinckieelIntelligencePage') }">
                        <img :src="require('@/assets/images/sidebar/IA.png')" style="filter: invert(1);" alt="winck-ia">&nbsp; Winckieel IA
                    </router-link>
                </li>
                <li class="sidebar-item">
                    <router-link
                        class="sidebar-link"
                        :class="{ active: isActive('UnidadeDetailsPage') }"
                        :to="'/v1/unidades/' + unidade.id">
                        <img :src="require('@/assets/images/sidebar/home.png')" alt="home">
                        <span
                            style="display: block; text-align: center"
                            >&nbsp; {{ unidade.nome }}
                        </span>
                    </router-link>
                </li>
                <li class="sidebar-item">
                    <a
                        class="sidebar-link"
                        :class="{ active: isActive('SiloDetailsPage') }"
                        href="#silosDropdown"
                        data-bs-toggle="collapse"
                        :aria-expanded="isActive('SiloDetailsPage') ? 'true' : 'false'">
                        <img :src="require('@/assets/images/sidebar/silos.png')" alt="silos">&nbsp; Silos

                    </a>
                    <ul :class="['collapse list-unstyled', { 'show': isActive('SiloDetailsPage') }]" id="silosDropdown">
                        <li v-for="silo in silos" :key="silo.id">
                            <router-link :to="'/v1/unidades/'+ silo.unidade_id +'/silos/' + silo.id" class="sidebar-link" :class="{ activeDropdwonItem: isActive('/v1/unidades/' + unidade.id + '/silos/' + silo.id) }"> {{ silo.nome }}</router-link>
                        </li>
                    </ul>
                </li>
                <li class="sidebar-item">
                <a
                        class="sidebar-link"
                        :class="{ active: isActive('RelatorioTermometriaPage') || isActive('RelatorioAeracaoPage') || isActive('RelatorioEstacaoPage') || isActive('RelatorioLogsPage')  }"
                        href="#relatoriosDropdown"
                        data-bs-toggle="collapse"
                        :aria-expanded="isActive('RelatorioTermometriaPage') || isActive('RelatorioAeracaoPage') || isActive('RelatorioEstacaoPage') || isActive('RelatorioLogsPage')  ? 'true' : 'false'">
                        <img :src="require('@/assets/images/sidebar/relatorio.png')" alt="relatorio">&nbsp; Relatórios

                    </a>
                <ul :class="['collapse list-unstyled', {'show': isActive('RelatorioTermometriaPage') || isActive('RelatorioAeracaoPage') || isActive('RelatorioEstacaoPage') || isActive('RelatorioLogsPage') }]" id="relatoriosDropdown">
                    <li>
                        <a class="sidebar-link" href="#relatoriosSilosDropdown" data-bs-toggle="collapse" :aria-expanded="isActive('RelatorioTermometriaPage') || isActive('RelatorioAeracaoPage')  ? 'true' : 'false'">
                            &nbsp; Silos/Armazéns
                        </a>
                        <ul id="relatoriosSilosDropdown" :class="['collapse list-unstyled', {'show': isActive('RelatorioTermometriaPage') || isActive('RelatorioAeracaoPage') }]">
                            <li>
                                <router-link 
                                    :to="'/v1/unidades/' + unidade.id + '/relatorios/silos/termometria'" 
                                    class="sidebar-link" 
                                    :class="{ activeDropdwonItem: isActive('RelatorioTermometriaPage') }">
                                    Termometria
                                </router-link>
                            </li>
                            <li>
                                <router-link 
                                    :to="'/v1/unidades/' + unidade.id + '/relatorios/silos/aeracao'" 
                                    class="sidebar-link" 
                                    :class="{ activeDropdwonItem: isActive('RelatorioAeracaoPage') }">
                                    Aeração
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <router-link 
                                    :to="'/v1/unidades/' + unidade.id + '/relatorios/estacao'" 
                                    class="sidebar-link"
                                    :class="{ activeDropdwonItem: isActive('RelatorioEstacaoPage') }">
                                    Histórico Meteorológico
                                    
                        </router-link>
                    </li>
                    <li>
                        <router-link 
                                    :to="'/v1/unidades/' + unidade.id + '/relatorios/logs'" 
                                    class="sidebar-link"
                                    :class="{ activeDropdwonItem: isActive('RelatorioLogsPage') }">
                                    Logs
                                    
                        </router-link>
                    </li>
                </ul>
            </li>
            <li class="sidebar-item">
                <a
                    class="sidebar-link"
                    :class="{ active: isActive('AddLeiturasPage') }"
                    href="#leiturasDropdown"
                    data-bs-toggle="collapse"
                    :aria-expanded="isActive('AddLeiturasPage') || isActive('LeiturasAutomaticasPage') ? 'true' : 'false'">
                    <img :src="require('@/assets/images/sidebar/clock.png')" alt="silos">&nbsp; Leituras

                </a>
                <ul :class="['collapse list-unstyled', { 'show': isActive('AddLeiturasPage') || isActive('LeiturasAutomaticasPage') }]" id="leiturasDropdown">
                    <li>
                        <router-link :to="'/v1/unidades/'+unidade.id+'/leituras/leituras-automaticas'" class="sidebar-link" :class="{ activeDropdwonItem: isActive('LeiturasAutomaticasPage') }"> Leituras Automáticas</router-link>
                    </li>
                    <li>
                        <router-link :to="'/v1/unidades/'+unidade.id+'/leituras/adicionar'" class="sidebar-link" :class="{ activeDropdwonItem: isActive('AddLeiturasPage') }"> Upload Leituras</router-link>
                    </li>
                </ul>
            </li>
            <li class="sidebar-item">
                <router-link 
                    class="sidebar-link"
                    :class="{ active: isActive('AeracaoPage') }"
                    :to="'/v1/unidades/' + unidade.id + '/configuracoes/aeracao'"
                    >
                    <img :src="require('@/assets/images/sidebar/settings.png')" alt="simulador">&nbsp; Aeração
                </router-link >
            </li>
        </ul>
        </div>
	</nav>
</template>
<script>
import { ref, watch, computed } from 'vue';
import { useStore } from 'vuex';

export default {
	methods: {
            getImageUrl(imagePath) {
                return `${process.env.VUE_APP_SERVER}/storage/${imagePath}`;
            },
            isActive(route) {
                return this.$route.name === route || this.$route.path.includes(route);
            }
        },
	setup() {
		const version = process.env.VUE_APP_VERSION;
		const store = useStore();
		const silos = ref([]);
		const unidade = ref({});
        const isCollapsed = computed(() => store.getters['ui/isSidebarCollapsed']);
        const isAdmin = computed(() => {
            const user = store.getters['auth/getUser'];
            return user && user.tipo_usuario === 'administrador';
        });

		watch(() => store.state.silos.silos,(newSilos) => {
				silos.value = newSilos;
			},{ immediate: true } 
		);

		watch(() => store.state.unidade.unidade, (newUnidade) => {
				unidade.value = newUnidade;
			}, { immediate: true }
		);

		return {
			unidade,
			silos,
			version,
            isCollapsed
            ,isAdmin
		};
	},
}
</script>
<style scoped>
	.avatar {
		width: 10vh;
		height: 10vh;
		border-radius: 50%;
		object-fit: cover;
	}

	.text-version {
		color: #fff !important;
	}

    .scroll-container {
        max-height: 100%;
        overflow-y: auto;
    }

    .scroll-container {
        scrollbar-width: thin !important;
    }

    .active {
        background-color: #33b35a;
        color: white;
        font-weight: 600;
    }

    .activeDropdwonItem {
        color: #33b35a;
        font-weight: 600;
    }
</style>
